import { createSlice } from "@reduxjs/toolkit";
import * as UserAPI from "../api/user";
const trainers = createSlice({
  name: "trainers",
  initialState: {
    loading: false,
    error: null,
    list: [],
    summary: null,
    serviceTypeStats: null,
  },
  reducers: {
    setLoading: (state) => {
      state.error = null;
      state.loading = true;
    },
    setError: (state, action) => {
      state.error = action.payload;
      state.loading = false;
    },
    getListSuccess: (state, action) => {
      state.list = action.payload.docs;
      state.summary = action.payload.summary;
      state.serviceTypeStats = action.payload.serviceTypeStats;
      state.loading = false;
    },
    updateTrainerSuccess: (state, action) => {
      state.list = state.list.map((trainer) => {
        if (trainer._id === action.payload._id) {
          return action.payload;
        } else {
          return trainer;
        }
      });
    },
    deleteTrainerSuccess: (state, action) => {
      state.list = state.list.filter(
        (item) => action.payload?._id !== item._id
      );
    },
  },
});

export const getListTrainer = (params) => async (dispatch) => {
  try {
    dispatch(setLoading());
    const res = await UserAPI.getListUser({
      ...params,
      roles: "service_provider",
      serviceTypes: "trainer",
    });
    dispatch(getListSuccess(res));
  } catch (error) {
    dispatch(setError(error));
  }
};

const { reducer, actions } = trainers;
export const {
  setLoading,
  setError,
  getListSuccess,
  deleteTrainerSuccess,
  updateTrainerSuccess,
} = actions;
export default reducer;
